var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5,
    fill: "white",
    stroke: "#21A6E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3346 12.3334V25.6667H10.668V12.3334H27.3346ZM24.8346 20.6667H19.8346V21.9167H24.8346V20.6667ZM24.8346 18.1667H19.8346V19.4167H24.8346V18.1667ZM18.168 15.6667H13.168V19.4167H18.168V15.6667ZM24.8346 15.6667H19.8346V16.9167H24.8346V15.6667Z",
    fill: "#21A6E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon12);
export default __webpack_public_path__ + "static/media/icon12.c2c43c38b408bbec41ce1a9628f24858.svg";
export { ForwardRef as ReactComponent };